import Model from "../Model";

export default class User extends Model {
    get url() {
        return '/api/users';
    }
}